import React from "react";
import parse from "html-react-parser";
import { Typography } from "@mui/material";
import Popup from "@/components/UI/popup/Popup";
import theme from "@/theme";
import { useNavigate } from "react-router-dom";

const CashtagLink: React.FC<{ symbol: string }> = ({ symbol }) => {
  const navigate = useNavigate();
  return (
    <Typography
      component="span"
      fontWeight={500}
      color={theme.palette.custom.mainBlue}
      sx={{ cursor: "pointer", fontSize: "inherit", lineHeight: "inherit" }}
      onClick={(e: React.MouseEvent) => {
        e.stopPropagation();
        navigate(`/stock/${symbol.startsWith("$") ? symbol.slice(1) : symbol}`);
      }}
    >
      {symbol}
    </Typography>
  );
};

export const parseStyle = (style: string) => {
  return style.split(";").reduce((acc, curr) => {
    const [key, value] = curr.split(":").map((s) => s.trim());
    if (key && value) {
      (acc as any)[key.replace(/-([a-z])/g, (_, char) => char.toUpperCase())] = value;
    }
    return acc;
  }, {} as React.CSSProperties);
};

export const safeParseHtml = (html: string) => {
  try {
    return parse(html, {
      replace: (domNode) => {
        if (domNode.type === "text" && domNode.data?.includes("$")) {
          const parts = domNode.data.split(/(\$[a-zA-Z]+)/g);
          return (
            <>
              {parts.map((part, index) => {
                if (/^\$[a-zA-Z]+$/.test(part)) {
                  return (
                    <Popup symbol={part} type="company" key={index}>
                      <CashtagLink symbol={part} />
                    </Popup>
                  );
                }
                return part;
              })}
            </>
          );
        }
      },
    });
  } catch (e) {
    console.warn("Invalid HTML, rendering as text:", html);
    return <span>{html}</span>;
  }
};
